<div class="glass-house-brand-logo">
  <img
    *ngIf="data | getVariantAssetForCard | push: 'immediate' as asset"
    appImage
    class="brand-logo"
    [asset]="asset"
    src=""
    alt="brand logo" />
</div>
